import { Box, Typography } from "@mui/material";
import ConsoleAPICard, { ConsoleAPICardProps } from "./Card/ConsoleAPICard";
import styles from "./ConsoleAPICards.module.scss";

type ConsoleAPICardsProps = {
	title?: string;
	cards: ConsoleAPICardProps[];
};

const ConsoleAPICards = ({ title, cards }: ConsoleAPICardsProps) => {
	return (
		<Box className={styles.container} id="automotive">
			{title && <Typography className={styles.title}>{title}</Typography>}
			<Box className={styles.cards}>
				{cards.map((card) => (
					<ConsoleAPICard {...card} />
				))}
			</Box>
		</Box>
	);
};

export default ConsoleAPICards;
